import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserAvatar from '../components/UserAvatar';

export default function AdminAccessDeniedPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F8F9FA] via-white to-[#E6F0F9] flex flex-col">
      <header className="w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 shadow-sm z-50">
        <div className="max-w-full mx-auto px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/home')}
              className="flex items-center gap-2 text-[#0054A4] hover:text-[#003A73] transition-colors"
            >
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-md p-1 border-t-2 border-[#E4002B]">
                <img src="/images/CVX_Logo_NoTagline_RGB.png" alt="Chevron Logo" className="w-full h-full object-contain" />
              </div>
              <span className="text-sm font-semibold">OT Operations</span>
            </button>
            <span className="text-gray-300">/</span>
            <span className="text-sm font-semibold text-gray-700">Admin Panel</span>
          </div>
          <UserAvatar />
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center px-6">
        <div className="max-w-xl w-full rounded-2xl border border-red-200 bg-white shadow-sm p-8 text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-red-50 border border-red-200 flex items-center justify-center mb-4">
            <svg className="w-7 h-7 text-red-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-[#1E3A5F] mb-2">Not Authorized</h1>
          <p className="text-sm text-gray-600 mb-6">
            You do not have permission to access the Admin Panel. Contact an administrator if you need elevated access.
          </p>
          <button
            onClick={() => navigate('/home')}
            className="px-4 py-2 rounded-lg bg-[#0054A4] hover:bg-[#003A73] text-white text-sm font-semibold transition-colors"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
}
